import { createStyles } from '@material-ui/core';

import Colours from 'bz-core-controls/styles/colours';

const styles = createStyles({
  subHeaderContainer: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'nowrap',
    flex: '1 1 auto',
    color: Colours.white
  },
  subHeaderAccent: {
    background: Colours.lightBlue500,
    flex: '0 0 11px',
    marginRight: 3,
    order: 0,
    flexFlow: 'column nowrap',
    marginBottom: 3
  },
  subHeaderContent: {
    flex: '1 1',
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'nowrap',
    marginBottom: 3,
    overflowX: 'auto',
    '& *': { display: 'flex', flex: '0 1 auto' }
  },
  subHeaderTabSpacing: {
    marginTop: 3
  },
  subHeader: {
    flex: '1 1 auto',
    padding: 4,
    '& *': { display: 'flex', flex: '0 1 auto' },
    background: Colours.blueGrey400
  },
  options: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignContent: 'center'
  }
});

export default styles;
